import React from 'react'
import styled from 'styled-components'

import Tooltip from 'components/Tooltip'
import KeyboardAccessible from 'components/KeyboardAccessible'

export type HealthStatus = 'critical' | 'fair' | 'great';

interface HealthStatusIconProps {
  status?: HealthStatus | string | null;
  className?: string;
  showToolTip?: boolean;
  onClick?: (event: React.MouseEvent | React.KeyboardEvent) => void;
  tooltipId?: string,
  tooltipContent?: string
}

const validHealthStatuses: HealthStatus[] = ['critical', 'fair', 'great']
const isHealthStatus = (s: string): s is HealthStatus => (validHealthStatuses as string[]).includes(s)

const HealthStatusIcon: React.FC<HealthStatusIconProps> = ({
  status = null,
  className,
  onClick,
  showToolTip = true,
  tooltipId = '',
  tooltipContent = ''
}) => {
  const imagePath: Record<HealthStatus, string> = {
    critical: '/img/health_icon_red.svg',
    fair: '/img/health_icon_yellow.svg',
    great: '/img/health_icon_green.svg'
  }

  if (!status || !isHealthStatus(status)) {
    return null
  }

  const src = imagePath[status]

  const iconTooltip =
    status === 'critical'
      ? 'This HVAC Performance Monitoring kit needs immediate attention.'
      : status === 'fair'
        ? 'This HVAC Performance Monitoring Kit needs maintenance.'
        : null

  const icon = (
    <img
      src={src}
      alt={`${status} health icon`}
      className={className}
      data-testid="health-status-icon"
      width={24}
      height={24}
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipContent}
    />
  )

  const interactiveIcon = (
    <S.Container onClick={onClick} readOnly={!onClick} enabled={Boolean(onClick)}>
      {icon}
    </S.Container>
  )

  return showToolTip ? (
    <Tooltip title={iconTooltip ?? ''} placement="top">
      {interactiveIcon}
    </Tooltip>
  ) : (
    interactiveIcon
  )
}

export default HealthStatusIcon

const S = {
  Container: styled(KeyboardAccessible)`
    margin-left: 5px;
    padding-top: 5px;
  `
}
